import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/index';
import { appConfig } from '../../configureApp';

function AsyncButton(props) {
  const {
    loading,
    onClick,
    className,
    children,
    spinner,
    disabled,
    id,
    onKeyDown,
  } = props;

  const buttonStyle = appConfig.reactAppEnv === 'scti' ? {
    borderRadius: '100px',
    backgroundColor: disabled ? '#b4b4b4' : '#008BCE',
    color: '#FFFFFF',
    fontFamily: 'Omnes',
    fontSize: '16px',
    fontWeight: '500',
    padding: '10px 20px',
    border: 'none',
    cursor: disabled || loading ? 'not-allowed' : 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } : {};

  return (
    <button
      disabled={loading || disabled}
      onClick={onClick}
      className={className}
      id={id}
      onKeyDown={onKeyDown}
      style={buttonStyle}
    >
      {spinner && <Icon name="fa-spinner fa-spin" style={{ marginRight: 5 }} />}
      {children}
    </button>
  );
}

AsyncButton.propTypes = {
  spinner: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.any,
  onKeyDown: PropTypes.any,
};

export default AsyncButton;



// WEBPACK FOOTER //
// ./app/components/AsyncButton/index.js